import store from "../../../../../store";
import { DomainRegistry } from "../../../../../domain";
import { RootDirectory } from "../../../../../domain/drawing";
import { FormatSet } from "../../../../../domain/format";
import { IConfiguration } from "../../../../../domain/configuration";
import { IEditTreeRootSource, ITreeRootSource } from ".";

export class DepartmentFavoriteFormatSetTreeSource implements ITreeRootSource<FormatSet>, IEditTreeRootSource<FormatSet> {
  constructor(private _departmentId: string, private _shouldIgnoreChained: boolean) {
  }

  private readonly config = store.getters.configuration as IConfiguration;
  public entityName: string = this.config.wording.common.departmentAsShort + "頻用" + this.config.wording.format.attributes.name + "セット情報";

  async getTreeRoot(): Promise<RootDirectory<string, FormatSet>> {
    if (this._departmentId === null) {
      return new RootDirectory([], []);
    }
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.getDepartmentFavoriteFormatSets(this._departmentId, this._shouldIgnoreChained);
  }

  async saveEditTreeRoot(root: RootDirectory<string, FormatSet>): Promise<void> {
    const repository = DomainRegistry.format.getFormatRepository();
    return repository.saveDepartmentFormatSets(this._departmentId, root);
  }

  get managementKey(): string {
    return this._departmentId;
  }
}
